import React from "react";
import { useNavigate } from "react-router-dom";
import "./Css/StudentView.css";
// import profile from "../Component/Images/Ellipse 24 (2).png"

const Setting = () => {
        const navigate = useNavigate();
        const handleEditClick = (index) => {
  navigate("/dashboard/teacheredit"); 
};

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3    style={{ cursor: "pointer" }}
        onClick={() => navigate(-1)}>
        <span>सेटिंग्ज</span>
        </h3>
        <button className="edit-btn" onClick={() => handleEditClick()} >एडिट करा</button>
      </div>

    <h2>शिक्षक प्रोफाइल</h2>
      <div className="profile-card">
        <img
          // src={profile}
          alt="student"
          className="profile-img"
        />
        <p className="updated-text">Last Updated 12/12/2024</p>
      </div>

      {/* Info Grid */}
      <div className="info-grid">
        <div className="info-box">
          <label>शिक्षकाचे नाव</label>
          <p>सौ. प्रिया देशमुख</p>
        </div>
         <div className="info-box">
          <label>ईमेल</label>
          <p>priya.deshmukh@gmail.com</p>
        </div>
         <div className="info-box">
          <label>मोबाईल नं.</label>
          <p>९८७६५४३२१०</p>
        </div>

        <div className="info-box">
          <label>नियुक्त इयत्ता</label>
          <p>पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा</p>
        </div>

        <div className="info-box">
          <label>नियुक्त परीक्षेचे नाव </label>
          <p>५ वी</p>
        </div>

        <div className="info-box">
          <label>नियुक्त विषय   </label>
          <p>मराठी </p>
        </div>
      </div>

      {/* Exam Table */}
      <div className="exam-section">
        <h2>शिक्षकाने घेतलेल्या परीक्षा</h2>

        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>परीक्षा नाव</th>
              <th>परीक्षा प्रकार </th>
              <th>इयत्ता</th>
              <th>विषय</th>
              <th>एकूण विद्यार्थ्यांची संख्या</th>
              <th>तारीख</th>
              <th>स्थिती</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>१</td>
              <td>पूर्व उ. मा. शिष्यवृत्ती परीक्षा</td>
            <td>परीक्षा प्रकार १</td> 
              <td>९ वी</td>
               <td>मराठी</td>
               <td>४०</td>
               <td>२० ऑगस्ट २०२४</td>
              <td className="pass">पूर्ण</td>
               </tr>

            <tr>
              <td>२</td>
              <td>ज. नवोदय विद्यालय प्रवेश परीक्षा</td>
            <td>परीक्षा प्रकार २</td> 
              <td>५ वी</td>
               <td>इंग्रजी </td>
               <td>५०</td>
               <td>२० जुलै २०२५</td>
              <td className="pass">पूर्ण</td>
            </tr>
              <tr>
              <td>३</td>
              <td>NMMS Exam</td>
            <td>परीक्षा प्रकार १</td> 
              <td>६ वी</td>
               <td>गणित </td>
               <td>४५</td>
               <td>१२ मार्च २०२५</td>
              <td className="pass">पूर्ण</td>
               </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Setting;
